import { Space } from 'antd';
import styled from 'styled-components';
import { type OptionSettingDetailsFragment } from '../../../../../api/fragments/OptionSettingDetails';
import { OptionType } from '../../../../../api/types';
import RadioField from '../../../../../components/fields/RadioField';
import { useThemeComponents } from '../../../../../themes';
import useCompanyFormats from '../../../../../utilities/useCompanyFormats';
import useTranslatedString from '../../../../../utilities/useTranslatedString';

const RadioContainer = styled.div`
    display: block;

    & .ant-radio-wrapper {
        margin-right: 0;

        & > span.ant-radio + span {
            width: 100%;
        }
    }
`;

const LabelContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Description = styled.div`
    margin-left: 1rem;
    font-weight: 900;
    text-align: right;
    white-space: nowrap;
`;

export type OptionRadioFieldProps = {
    name: string;
    optionSetting: OptionSettingDetailsFragment;
    companyId: string;
};

const OptionRadioField = ({ name, optionSetting, companyId }: OptionRadioFieldProps) => {
    const translatedString = useTranslatedString();
    const companyFormats = useCompanyFormats(companyId);

    const { Radio } = useThemeComponents();

    if (optionSetting.__typename !== 'SingleSelectOptionSettings') {
        return null;
    }

    return (
        <RadioField name={name} size="large" style={{ width: '100%' }}>
            <Space direction="vertical" style={{ display: 'flex' }}>
                {optionSetting.options.map(option => (
                    <RadioContainer key={option.id}>
                        <Radio value={option.id}>
                            <LabelContainer>
                                {translatedString(option.label)}
                                <Description>
                                    {option.type === OptionType.Price
                                        ? companyFormats.formatAmountWithCurrency(option.valuePrice)
                                        : translatedString(option.valueText)}
                                </Description>
                            </LabelContainer>
                        </Radio>
                    </RadioContainer>
                ))}
            </Space>
        </RadioField>
    );
};

export default OptionRadioField;
